module.exports = {
      id: "arcade-usage",
      viewBox: "0 0 19.915 20.731",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#arcade",
      toString: function () {
        return this.url;
      }
    }